import { Spin } from 'antd';
import { TreemapChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface TreemapNode {
  name: string;
  value?: number;
  children?: TreemapNode[];
}
type Data = TreemapNode[];

function TreemapWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'treemap', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <TreemapChart data={data ?? []} />;
}

export const treemapWidgetDef: WidgetDefinition = {
  type: 'treemap',
  name: 'Treemap',
  description: 'Hierarchical proportion',
  icon: 'TableOutlined',
  category: 'chart',
  defaultTitle: 'Treemap',
  defaultConfig: {},
  minW: 4, minH: 4, defaultW: 6, defaultH: 6,
  component: TreemapWidget,
  settingsSchema: { fields: [] },
};
